/**
 * Created by Ning Jiang on 2022-02-21.
 */

import {SerialSymbol} from "./SerialSymbol";
import {SerialSymbolState} from "./SerialSymbolConfig";
import {Serial} from "../Serial";
import {gsap} from "gsap";
import {ReelPositionController} from "../reels/ReelPositionController";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {SerialGameAssets} from "../SerialGameAssets";
import {SerialSound} from "../sound/SerialSound";

export class EnhancerWXNSymbol extends SerialSymbol {

    private _spine:PIXI.spine.Spine;
    private _animationContainer:PIXI.Container;

    private _currentMultiplier:number = 0;
    public get currentMultiplier() {
        return this._currentMultiplier;
    }

    constructor(symbolName:string, reelId:number, initState:SerialSymbolState) {
        super(symbolName, reelId, ReelPositionController.DEFAULT_SYMBOL_HEIGHT * 0.5, initState);
        this.blockReelLandingSound = true;
    }

    protected initAnimation() {
        super.initAnimation();

        this._animationContainer = new PIXI.Container();
        this._animationContainer.position.set(this._centerPosition.x, this._centerPosition.y);

        this._multiplierContainer = new PIXI.Container();
        this._multiplierContainer.position.set(this._centerPosition.x, this._centerPosition.y);

        this._multiplierText = new PIXI.BitmapText("", {
            fontName : SerialGameAssets.BITMAP_FONT_NUDGE_MULTIPLIER,
            fontSize : 38,
            tint : 0xffffff
        });
        this._multiplierText.letterSpacing = -15;
        (<PIXI.Point>this._multiplierText.anchor).set(0.5, 0.7);
        this._multiplierContainer.addChild(this._multiplierText);
    }

    protected getStateTexture(state?:SerialSymbolState):PIXI.Texture[] {
        let texturePath = `${this.symbolName}/${this.symbolName}`;
        texturePath += `_S`;
        if(state === SerialSymbolState.SPIN) {
            texturePath += `_${state}`;
        }

        return Serial.assetLoader.getTextures(texturePath);
    }

    public playLanding():gsap.core.Timeline{
        const tl = gsap.timeline();

        this.prepareSpine();
        tl.add([
            () => {
                this._spine.state.setAnimation(0, "animation", false);
                SerialSound.soundPlayer.playTrack({name : SerialSound.NUDGE_LANDING})
            },
            this.updateMultiplier(1, true)
        ]);

        return tl;
    }

    public updateMultiplier(value:number, animate:boolean):gsap.core.Timeline {
        Logger.logDev(`wild update to multiplier ${value} on reel ${this.reelId}`);
        const tl = gsap.timeline();
        if(value === this.currentMultiplier) {
            return tl;
        }

        this._currentMultiplier = value;
        this._multiplierText.text = `X${value}`;

        if(animate) {
            // this._multiplierGlow.texture = TombstoneRip.assetLoader.getTextures(`wild/multiplier/x${value}`)[0];
            tl.add([
                gsap.to(this._multiplierContainer.scale, {x : 1.5, y : 1.3, duration : 0.1}),
                //     gsap.to(this._multiplierGlow, {alpha : 1, duration : 0.1})
            ]);
            tl.add([
                gsap.to(this._multiplierContainer.scale, {x : 1, y : 1, duration : 0.5}),
                //     gsap.to(this._multiplierGlow, {alpha : 0, duration : 0.5})
            ]);
        }

        return tl;
    }

    private prepareSpine():void {
        if(!this._spine) {
            this._spine = new PIXI.spine.Spine(Serial.assetLoader.getSpineAsset("xNudgeEnhancer"));
            this._spine.autoUpdate = true;
            this._animationContainer.addChild(this._spine);
            // if(this._heightMask) {
            //     this._spine.mask = this._heightMask;
            // }
        }
    }

    protected updateLayers() {
        if(this._animationContainer) {
            this.addChild(this._animationContainer);
        }
        super.updateLayers();
    }
}